import React, {FC} from "react";
import {Button, Space, Typography} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {useRegistrationCopy} from "./registrationCopy";
import type {PublicEventAssetLink} from "./types";

export const EventMaterials: FC<{links: PublicEventAssetLink[]}> = ({links}) => {
    const {labels} = useRegistrationCopy();

    if (links.length === 0) {
        return null;
    }

    return (
        <section className="public-registration-assets" aria-label={labels.eventMaterials}>
            <Typography.Text className="public-registration-assets-title">
                {labels.eventMaterials}
            </Typography.Text>
            <Space wrap>
                {links.map(asset => (
                    <Button
                        key={asset.key}
                        icon={<DownloadOutlined/>}
                        href={asset.href}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {asset.label}
                    </Button>
                ))}
            </Space>
        </section>
    );
};
